import styled from 'styled-components'

export const ContainerImage = styled.div`
  width: 100%;

  cursor: pointer;
  position: relative;

  &:hover::before {
    content: 'Copiar link';
    position: absolute;
    top: 0;
    right: 0;

    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;

    padding: 5px 10px;
    border-radius: 0 0 0 5px;

    transition: all 0.3s ease-in-out;
  }
`
